export const getUser = () => {

    var data = localStorage.getItem('user');

    if (!data)
        return null;

    var ret = JSON.parse(data);


    //if expired
    if (!ret.expires || new Date() > new Date(ret.expires)) {
        removeUser();
        return null;
    }

    return ret;
};

export const setUser = (data) => {
    localStorage.setItem('user', data);
}

export const removeUser = () => {
    localStorage.removeItem('user');
}


export const getUserRegion = () => {
    var ret = localStorage.getItem('region');

    return ret ? ret : 'CAD';
}

export const setUserRegion = (data) => {
    localStorage.setItem('region', data);
}



// WEBPACK FOOTER //
// ./src/helpers/userStorage.js